import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import Button from '@ts-core/components/Button';

import { PracticeExercise, PracticeSubject } from '../../types';
import SelectedExercisesList from '../SelectedExercisesList';
import AvailableExercisesList from '../AvailableExercisesList';

export interface PracticeSessionFormProps {
  selectedExercises: PracticeExercise[];

  onSelectExercise: (exercise: PracticeExercise) => void;
  onSelectSubjectExercises: (subject: PracticeSubject) => void;
  onRemoveExercise: (exercise: PracticeExercise) => void;
  onSortExercises: (from: number, to: number) => void;
  isExerciseSelected: (exercise: PracticeExercise) => boolean;
  onRemoveAllExercises: () => void;

  onCreatePracticeSession: () => void;
  createPracticeSessionLoading: boolean;

  subjects?: PracticeSubject[];
  loading: boolean;
}

export const PracticeSessionForm = (props: PracticeSessionFormProps) => {
  const {
    selectedExercises,
    onRemoveExercise,
    onCreatePracticeSession,
    subjects,
    onSelectSubjectExercises,
    onSortExercises,
    onSelectExercise,
    isExerciseSelected,
    createPracticeSessionLoading,
  } = props;
  const intl = useIntl();
  const handleCreatePracticeSession = useCallback(() => {
    onCreatePracticeSession();
  }, [onCreatePracticeSession]);

  return (
    <>
      <Box width="100%" minWidth={{ xs: '100%', sm: 600 }} pb={6} height="100%" overflow="auto">
        <Grid container spacing={2} style={{ height: '100%' }}>
          <Grid item xs={6} style={{ height: '100%' }}>
            <AvailableExercisesList
              practiceSubjects={subjects || []}
              onSelectExercise={onSelectExercise}
              onSelectSubjectExercises={onSelectSubjectExercises}
              isExerciseSelected={isExerciseSelected}
            />
          </Grid>
          <Grid item xs={6} style={{ height: '100%' }}>
            <SelectedExercisesList exercises={selectedExercises} onRemoveExercise={onRemoveExercise} onSortExercises={onSortExercises} />
          </Grid>
        </Grid>
      </Box>
      <Box
        width="100%"
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        position="absolute"
        bgcolor="background.paper"
        bottom={0}
        left={0}
        px={2}
        py={2}
      >
        <Button
          variant="contained"
          color="primary"
          type="submit"
          loading={createPracticeSessionLoading}
          disabled={selectedExercises.length === 0}
          onClick={handleCreatePracticeSession}
        >
          {intl.formatMessage({ id: 'practice' })}
        </Button>
      </Box>
    </>
  );
};

export default PracticeSessionForm;
